import { render, staticRenderFns } from "./MaterialityFiltersHeader.vue?vue&type=template&id=a5fecf2a&scoped=true"
import script from "./MaterialityFiltersHeader.vue?vue&type=script&lang=js"
export * from "./MaterialityFiltersHeader.vue?vue&type=script&lang=js"
import style0 from "./MaterialityFiltersHeader.vue?vue&type=style&index=0&id=a5fecf2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fecf2a",
  null
  
)

export default component.exports